import { render, staticRenderFns } from "./AdminFlow.vue?vue&type=template&id=a39721da&"
import script from "./AdminFlow.vue?vue&type=script&lang=js&"
export * from "./AdminFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports